import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const COMMENT_REQUEST = 'sherrinford/Project/comment/COMMENT_REQUEST'
export const COMMENT_SUCCESS = 'sherrinford/Project/comment/COMMENT_SUCCESS'
export const COMMENT_ERROR = 'sherrinford/Project/comment/COMMENT_ERROR'

export const DELETE_COMMENT_REQUEST = 'sherrinford/Project/comment/DELETE_COMMENT_REQUEST'
export const DELETE_COMMENT_SUCCESS = 'sherrinford/Project/comment/DELETE_COMMENT_SUCCESS'
export const DELETE_COMMENT_ERROR = 'sherrinford/Project/comment/DELETE_COMMENT_ERROR'

export const POST_COMMENT_REQUEST = 'sherrinford/Project/comment/POST_COMMENT_REQUEST'
export const POST_COMMENT_SUCCESS = 'sherrinford/Project/comment/POST_COMMENT_SUCCESS'
export const POST_COMMENT_ERROR = 'sherrinford/Project/comment/POST_COMMENT_ERROR'

export const IS_LOADING = 'sherrinford/Project/comment/IS_LOADING'
export const DATA = 'sherrinford/Project/comment/DATA'
export const SET_INPUT_COMMENT = 'sherrinford/Project/comment/SET_INPUT_COMMENT'

const initialState = {
  data: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
    qs: {
      skip: 0,
      limit: 10,
      sort: '',
    },
  },
  isLoading: false,
  isError: false,
  errorMessage: '',
  inputComment: '',
}

export default createReducer(initialState, {
  [SET_INPUT_COMMENT]: (state, inputComment) => ({
    ...state,
    inputComment,
  }),
  [POST_COMMENT_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [POST_COMMENT_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [POST_COMMENT_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
  [COMMENT_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [COMMENT_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [COMMENT_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [DELETE_COMMENT_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [DELETE_COMMENT_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [DELETE_COMMENT_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [DATA]: (state, data) => ({
    ...state,
    data,
  }),
})

export const getComments = (qs, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      COMMENT_REQUEST,
      COMMENT_SUCCESS,
      COMMENT_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/order_comment',
      authorization: `${token}`,
      qs,
    },
    nextAction: (res) => {
      cb(res)
    },
  }
}

export const postComments = (payloads, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      POST_COMMENT_REQUEST,
      POST_COMMENT_SUCCESS,
      POST_COMMENT_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/order_comment',
      authorization: `${token}`,
      payloads,
    },
    nextAction: (res) => {
      cb(res)
    },
  }
}

export const deleteComment = (commentId, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      DELETE_COMMENT_REQUEST,
      DELETE_COMMENT_SUCCESS,
      DELETE_COMMENT_ERROR,
    ],
    shuttle: {
      method: 'PUT',
      path: `/order_comment/${commentId}/status`,
      authorization: token,
      payloads: {
        isDeleted: true,
      },
    },
    nextAction: res => cb(res),
  }
}

export const setComment = data => ({
  type: [SET_INPUT_COMMENT],
  payload: data,
})

export const setData = data => ({
  type: [DATA],
  payload: data,
})


export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})
